'use strict';
Ilduomo.controller('operadoresKilometrajeCtrl', function ($scope) {
   
   $scope.pedidos = [];
    
});